// dependencies
import 'aos';
import 'tiny-slider';
import 'typed.js';
import 'choices.js';
import '@lottiefiles/lottie-player';

// own modules
import './components/sticky-navbar';
import './components/tooltip';
import './components/popover';
import './components/toast';
import './components/carousel';
import './components/animation-on-scroll';
import './components/smooth-scroll';
import './components/custom-select';
import './components/form-validation';
import './components/form-wizard';
import './components/form-currency-selection';
